const contextAddResourceData = (resourceData, context, prefix = '') => {
  for (const key in resourceData) {
    const value = resourceData[key];

    context[`INFO:${prefix}${key}`] = value;
  }
};

export default contextAddResourceData;
